import { OAuthError, ApiError, ParsedApiError } from 'models/error';

export function isOAuthError(a: unknown): a is OAuthError {
  return !!a?.hasOwnProperty('error') && a.hasOwnProperty('error_description');
}

export function isApiError(a: unknown): a is ApiError {
  return !!a?.hasOwnProperty('code') && Array.isArray((a as ApiError).reasons);
}

export const errorParser = (error: unknown): ParsedApiError[] => {
  if (error && isOAuthError(error)) {
    return [
      {
        error: error.error,
        message: error.error_description,
      },
    ];
  }

  if (error && isApiError(error)) {
    return [
      {
        error: error.code,
        message: error.message,
        reasons: error.reasons,
      },
    ];
  }

  return [
    {
      error: 'UNKNOWN',
      message: 'Unknown error, you may contact administrator',
    },
  ];
};
